import { isEmpty } from 'lodash';
import type {
    IProcessActivityReadSection,
    ProcessActivityReadSectionItemType,
} from '@common/interfaces/processActivityReadSection';
import { isGenericKey } from '@common/formEngine/generic/genericFields';
import type { ComponentsMap } from './readForm.types';

export function shouldIncludeItem(item: ProcessActivityReadSectionItemType, components?: ComponentsMap): boolean {
    return !isEmpty(item.value) || (components?.has(item.key) && item.value !== null) || isGenericKey(item.key);
}

export function getFilteredSections(
    sections: IProcessActivityReadSection[],
    components?: ComponentsMap
): IProcessActivityReadSection[] {
    return sections
        .map((section) => ({
            ...section,
            items: section.items.filter((item) => shouldIncludeItem(item, components)),
            subsections: section.subsections
                ?.map((subsection) => ({
                    ...subsection,
                    items: subsection.items.filter((item) => shouldIncludeItem(item, components)),
                }))
                .filter((subsection) => subsection.items.length),
        }))
        .filter(
            (section) => section.items.length || section.subsections?.some((subsection) => subsection.items.length)
        );
}
